export default function(dom, opts) {
	let options = {
		parent: '',
		target: '',
		class: '',
		...opts
	};

	let target;

	if (options.target) {
		target = document.querySelector(options.target);
	}
	else if (options.parent) {
		target = dom.closest(options.parent);
	}

	if (target && options.class) {
		dom.addEventListener('click', e => {
			e.preventDefault();

			target.classList.toggle(options.class);
		});
	}
}
